import React, { useState, useEffect } from "react";
import * as BosWebGuiServices from "data/BosWebServices/BosWebGuiServices";
import ErrorMessageView from "components/ErrorMessageView";
//import { sizes } from 'logic/media-query';

// Externals
import cn from "classnames";

// DevExtreme components
import { TreeView } from 'devextreme-react';

// Component styles
import classes from "./Shared.module.scss";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sessionActions from "redux/actions/sessionActions";
import * as dataSegmentActions from "redux/actions/dataSegmentActions";

function AllTasks(props) {
  const { currentDataSegment, currentSessionId, currentUILanguageCode, navigateTo } = props;

  const [tasks, setTasks] = useState([]);
  const [error, setError] = useState(false);
  const [shownNodes, setShownNodes] = useState({});

  const currentLocation = props.history.location.pathname;

  //const isMobile = !(sizes()['screen-large']) && !(sizes()['screen-medium']);

  useEffect(() => {
    async function fetchData() {
      try {
        console.log("GetUserTasks for session " + currentSessionId)
        let result = await BosWebGuiServices.fetchGetUserTasks(currentDataSegment.authToken, currentSessionId, currentDataSegment.id);
        console.log("GetUserTasks for DataSegmentId " + currentDataSegment.id + " result:", result);
        setTasks(toDataStructure(result, 0));
        setError(false);
      } catch (error) {
        console.error("UserTasks for DataSegmentId " + currentDataSegment.id + " error:", error);
        setTasks();
        setError(true);
      }
    }

    if (currentDataSegment && currentSessionId) fetchData();
    else setTasks();

  }, [currentDataSegment, currentSessionId, currentUILanguageCode]);

  const toDataStructure = (groups, running) => {
    let result = [];
    (groups || [])
      .filter(tg => (tg.subGroups && tg.subGroups.length > 0) || (tg.tasks && tg.tasks.length > 0))
      .forEach(tg => {
        running++;
        let id = toId(tg.name, running);
        let expanded = shownNodes[id] === true;
        let items = [...toDataStructure(tg.subGroups, running), ...(tg.tasks || [])];
        result = [...result, { ...tg, id: id, expanded: expanded, items: items }];
      });
    return result;
  };

  const toId = (text, suffix) => {
    return text.replace(/\s/g, "_") + "*" + suffix;
  }

  function onTreeViewItemClicked(args) {
    let target = args.itemData.targetUri;
    if (!target) return;
    openUri(target);
  }

  function openUri(targetUri) {
    if (!targetUri.startsWith("/")) targetUri = "/" + targetUri;
    navigateTo(targetUri);
  }

  function onTreeViewItemCollapsed(args) {
    let key = args.itemData.id;
    //console.log("collapse", key, shownNodes);
    setShownNodes(prev => ({ ...prev, [key]: false }));
  }

  function onTreeViewItemExpanded(args) {
    let key = args.itemData.id;
    //console.log("expand", key, shownNodes);
    setShownNodes(prev => ({ ...prev, [key]: true }));
  }

  function renderTreeViewItem(args) {
    const item = args.data;
    const isTask = item.targetUri && item.targetUri !== "";
    const isCurrent = item.targetUri && currentLocation.includes(item.targetUri);

    return (
      <div className={classes.treeViewItemContainer}>
        <div className={
          cn({
            "ui-font-bold-1": !isTask,
            "dx-theme-accent-as-text-color": isCurrent
          })
        }
        >
          {isTask ? item.shortName : item.name}
        </div>
      </div>
    );
  }

  return (
    <div className={classes.rootContainer} >
      {error
        ? <ErrorMessageView />
        : (
          <TreeView
            dataSource={tasks}
            itemsExpr="items"
            itemComponent={renderTreeViewItem}
            focusStateEnabled={false}
            onItemClick={onTreeViewItemClicked}
            onItemCollapsed={onTreeViewItemCollapsed}
            onItemExpanded={onTreeViewItemExpanded}
            noDataText=""
          />
        )
      }

    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    currentDataSegment: state.dataSegments.currentDataSegment,
    currentSessionId: state.sessions.currentSessionId,
    currentUILanguageCode: state.appState.uiLanguageIsoCode,
    currentDataViewLanguageCode: state.appState.dataViewLanguageIsoCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sessionActions: bindActionCreators(sessionActions, dispatch),
    dataSegmentActions: bindActionCreators(dataSegmentActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllTasks);
